/* eslint-disable parog-web/no-glint-expect-error-directive */
import { get } from '@ember/object';
import Component from '@glimmer/component';
import Dropdown2 from 'ui-kit/components/dropdown';
import ValidatedField from 'ui-kit/components/validated-field';

import type { EmberChangeset } from 'ember-changeset';
import type { Signature as DropdownSignature } from 'ui-kit/components/dropdown';

interface Signature {
  Element: DropdownSignature['Element'];
  Args: {
    propertyName: string;
    onChangesetUpdate?: (changeset: EmberChangeset) => void;
    changeset: EmberChangeset;
    onChange?: (value: string | string[]) => void;
  } & Partial<
    Pick<
      DropdownSignature['Args'],
      | 'onChange'
      | 'onSearch'
      | 'labelName'
      | 'isReadOnly'
      | 'placeholder'
      | 'isMandatory'
      | 'multipleSelection'
      | 'clearable'
      | 'allowAdditions'
      | 'translationKey'
      | 'size'
      | 'fullTextSearch'
    >
  >;
  Blocks: DropdownSignature['Blocks'];
}

/**
 * This component manages two types of data depending of the simple selection or
 * the multiple selection.
 *
 * - A single selection manage a string
 * - A multiple selection manage an array of strings.
 *
 * It can used using a changeset or as a classic component with an
 * `onChange` callback and `selected` attribute.
 */
export default class Dropdown extends Component<Signature> {
  onChange = (value: string | string[]) => {
    this.args.changeset[this.args.propertyName] = value;
    this.args.onChange?.(value);
  };

  <template>
    <ValidatedField
      @propertyName={{@propertyName}}
      @changeset={{@changeset}}
      @errorClass='error-validated-input-display'
    >
      <Dropdown2
        {{! @glint-expect-error }}
        @selected={{get @changeset @propertyName}}
        @onChange={{this.onChange}}
        @onSearch={{@onSearch}}
        @labelName={{@labelName}}
        @isReadOnly={{@isReadOnly}}
        @placeholder={{@placeholder}}
        @propertyName={{@propertyName}}
        @isMandatory={{@isMandatory}}
        @multipleSelection={{@multipleSelection}}
        @clearable={{@clearable}}
        @allowAdditions={{@allowAdditions}}
        @translationKey={{@translationKey}}
        @size={{@size}}
        @fullTextSearch={{@fullTextSearch}}
        ...attributes
        as |dropdown|
      >
        {{yield dropdown}}
      </Dropdown2>
    </ValidatedField>
  </template>
}
